import { connect } from 'react-redux';
import { toggleRouteUpdateAction } from '../actions/mvk_state';
import { NewbuildingMVK } from '../components/mvk';
var mapStateToProps = function mapStateToProps(state) {
  return {
    isFullScreen: state.MVKState.isFullScreen
  };
};
var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    handleUndoRedoButtonClick: function handleUndoRedoButtonClick() {
      return dispatch(toggleRouteUpdateAction());
    }
  };
};
export var NewbuildingMVKContainer = connect(mapStateToProps, mapDispatchToProps)(NewbuildingMVK);